import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { ISLANDS, islandUrl } from "@/lib/translations";
import { filterPlaces } from "@/lib/landingBlocks";

export const BlockHeading = ({ placed, children }) => placed
  ? <h2 className="font-serif text-2xl md:text-3xl text-stone-900 mb-4">{children}</h2>
  : <div className="text-xs uppercase tracking-[0.3em] text-brand mb-3">{children}</div>;

/** Chip-Liste mit Orten – nur Orte mit mindestens einem Ferienobjekt (Insel-, Regions- und Ortsseiten). */
export const PlaceChips = ({ places, base, heading, placed = true, testId = "island-places", chipId = "place-link" }) => {
  const list = places.filter((p) => p.property_count > 0);
  if (!list.length) return null;
  return (
    <div className={placed ? "" : "mt-10"} data-testid={testId}>
      <BlockHeading placed={placed}>{heading}</BlockHeading>
      <div className="flex flex-wrap gap-2">
        {list.map((p) => (
          <Link key={p.slug} to={`${base}/${p.slug}`} className="inline-flex items-center h-10 px-5 rounded-md border text-sm font-medium transition-colors bg-tint border-line hover:bg-brand hover:text-white" data-testid={`${chipId}-${p.slug}`}>
            {p.name}<span className="opacity-60 ml-1">({p.property_count})</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

/** Orte einer Insel (lädt selbst, wenn keine Liste übergeben wird); slugs = Auswahl (leer = alle), exclude = aktueller Ort. */
export const PlacesBlock = ({ island, slugs, exclude, heading, placed = true, places: given, testId }) => {
  const [loaded, setLoaded] = useState(given || null);
  useEffect(() => { if (!given && island) api.get("/places", { params: { island } }).then((r) => setLoaded(r.data)).catch(() => setLoaded([])); }, [island, given]);
  return <PlaceChips places={filterPlaces(given || loaded || [], slugs, exclude)} base={islandUrl(island)} heading={heading} placed={placed} testId={testId} />;
};

export const IslandsBlock = ({ island, placed = true }) => {
  const { t } = useLang();
  return (
    <div className={placed ? "" : "mt-10"} data-testid="island-others">
      <BlockHeading placed={placed}>{t.island.others}</BlockHeading>
      <div className="flex flex-wrap gap-2">
        {ISLANDS.filter((i) => i !== island).map((i) => (
          <Link key={i} to={islandUrl(i)} className="inline-flex items-center h-10 px-5 rounded-md border border-stone-300 text-sm font-medium hover:border-brand hover:text-brand transition-colors" data-testid={`island-link-${i}`}>{t.islands[i]}</Link>
        ))}
      </div>
    </div>
  );
};
